import "../../../src/ui/tokens.css";
import "../../../src/ui/forms.css";

/**
 * Views of one page as links on the segmented track, such as a guide's Simple and Detailed: each
 * option has its own address, and the current one carries `aria-current="page"`. It looks like
 * RadioGroup's `segmented` variant (forms.css), which stays the choice for a value in a form.
 * No script: the links work as links, Tab moves between them, and `preserveScroll` keeps the
 * reader's place when the site's navigation switches views.
 *
 * Parts: `.ui-segmented-links` (Root, a labelled `<nav>`), `.ui-segmented-links-link` (Link,
 * `[aria-current]` when current).
 */
export function SegmentedLinks({
  label,
  links,
  preserveScroll = false,
  className,
}: {
  /** Names the navigation for screen readers. */
  label: string;
  links: readonly { href: string; label: string; current?: boolean }[];
  preserveScroll?: boolean;
  className?: string;
}) {
  return (
    <nav
      className={["ui-segmented-links", className].filter(Boolean).join(" ")}
      data-ui="segmented-links"
      aria-label={label}
    >
      {links.map((link) => (
        <a
          key={link.href}
          className="ui-segmented-links-link"
          href={link.href}
          aria-current={link.current ? "page" : undefined}
          data-preserve-scroll={preserveScroll ? "" : undefined}
        >
          {link.label}
        </a>
      ))}
    </nav>
  );
}
